<template>
  <CDialog v-model="isOpen" class="dialog--small">
    <header class="dialog-header align-items-start">
      <div class="flex-fill pdgr">
        <h1 class="h4 mrgv0">
          {{ $t('planification.users.delete.title') }}
        </h1>
        <h2 v-if="user && user.user" class="h5 text-alt mrgt-- mrgb0">
          {{ user.user.label }}
        </h2>
      </div>

      <Btn variant="icon" @click="isOpen = !isOpen">
        <Icon id="close" :scale="0.75" />
      </Btn>
    </header>

    <main class="dialog-body">
      {{ $t('planification.users.delete.message') }}
    </main>

    <div class="dialog-footer">
      <ListInline align="center" size="small">
        <li>
          <Btn variant="outline" @click="isOpen = false">
            {{ $t('common.cancel') }}
          </Btn>
        </li>
        <li>
          <Btn variant="danger" @click="deleteUser">
            <div class="flex">
              <Loader v-if="loading" size="small" negative />
              <template v-else>
                {{ $t('common.delete') }}
              </template>
            </div>
          </Btn>
        </li>
      </ListInline>
    </div>
  </CDialog>
</template>

<script>
import eventBus from '@/eventBus';

import Loader from '@/components/ui/Loader';

export default {
  components: {
    Loader,
  },

  data() {
    return {
      isOpen: false,
      loading: false,
      group: null,
      user: null,
    };
  },

  watch: {
    isOpen(isOpen) {
      if (!this.isOpen) {
        this.group = null;
        this.user = null;
      }
    },
  },

  mounted() {
    eventBus.$on('togglePlanificationUserDelete', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('togglePlanificationUserDelete', this.handleToggle);
  },

  methods: {
    handleToggle({ group, user }) {
      this.group = group;
      this.user = user;

      this.isOpen = !this.isOpen;
    },

    deleteUser() {
      this.loading = true;
      this.$store
        .dispatch('planification/deleteGroupUser', this.user)
        .then(() => {
          this.isOpen = false;
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error.message || error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
